var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoaderComponent',{attrs:{"delay":0,"value":"","theme":"default"}})
}
var staticRenderFns = []

export { render, staticRenderFns }